'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.bestLocaleFor = undefined;

var _Countries = require('./Countries');

var Countries = _interopRequireWildcard(_Countries);

var _Locales = require('./Locales');

var Locales = _interopRequireWildcard(_Locales);

var _Languages = require('./Languages');

var Languages = _interopRequireWildcard(_Languages);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var bestLocaleFor = exports.bestLocaleFor = function bestLocaleFor(_ref) {
	var language = _ref.language,
	    _ref$country = _ref.country,
	    country = _ref$country === undefined ? 'ZZ' : _ref$country;

	var locale = language + '_' + country;

	// For valid locales, just return the locale
	if (_lodash2.default.includes(Locales.all, locale)) {
		return locale;
	}

	// For invalid locales, fall back to a same-language locale in the country that has the most speakers of this language.
	var langaugeLargestCountry = Languages.largestCountries[language];
	if (langaugeLargestCountry && _lodash2.default.includes(Locales.all, language + '_' + langaugeLargestCountry)) {
		return language + '_' + langaugeLargestCountry;
	}

	// If unknown, use any valid locale with the same language.
	var validLocale = _lodash2.default.find(Locales.all, function (locale) {
		return locale.substr(0, 2) === language;
	});
	if (validLocale) {
		return validLocale;
	}

	// If all else fails, use English (United States)
	return 'en_US';
};